import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 1. Import Bootstrap CSS (handles all layout and styling)
// import 'bootstrap/dist/css/bootstrap.min.css';
// 2. Import Bootstrap JavaScript bundle (handles tooltips, dropdowns, modals, etc.)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './bootstrap-purged.min.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
